/* eslint-disable */
import React from 'react';
import { ContentSpacer } from '../TCSMApp/global/components/layout/generic-content-spacer';
import { dividerSectionStyles } from '../TCSMApp/global/constants/theme/styles/layout/dividersection-styles';
//import { ClericIndicator } from '../../../pages/account-info/components/cleric-indicator';


interface Props {
	sectionText?: string;
	secondarySectionNode?: JSX.Element;
	sectionDescription?: string;
	showCleryIcon?: boolean;
	removeDivider?: boolean;
	greySection?: boolean;
	topDivider?: boolean;
	dashedBorder?: boolean;
}
export const DividerSection = (props: React.PropsWithChildren<Props>) => {
	const dividerSectionClasses = dividerSectionStyles();
	const getDividerClasses = () => {
		if (props.topDivider) {
			return dividerSectionClasses.topDivider;
		}
		if (props.dashedBorder) {
			return `${dividerSectionClasses.dividerSection} dashed-border`;
		}
		return props.removeDivider ? dividerSectionClasses.genericSection : dividerSectionClasses.dividerSection;
	};
	return (
		<>
			<div className={getDividerClasses()}>
				<div className={props.greySection ? dividerSectionClasses.grayBackground : ''}>
					<ContentSpacer hide={!props.sectionText && !props.sectionDescription}>
						<div className={dividerSectionClasses.dividerHeader}>
							<div className='divider-header-inner'>
								{
									/*
									props.showCleryIcon ?
										<ClericIndicator /> : null
									 */
								}
								<h2>{props.sectionText}</h2>
							</div>
							
							{props.secondarySectionNode}
						</div>

						<div dangerouslySetInnerHTML={{ __html: props.sectionDescription }} />

					</ContentSpacer>
					<div className={dividerSectionClasses.dividerSectionContent}>
						{props.children}
					</div>
				</div>
			</div>
		</>
	);
};


DividerSection.defaultProps = {
	sectionText: null,
	secondarySectionNode: null,
	sectionDescription: null,
	showCleryIcon: false,
	removeDivider: false,
	greySection: false,
	topDivider: false,
	dashedBorder: false,
	disabledOverlay: false,
};